import { render } from "./AssociatedPracticeDialog.vue?vue&type=template&id=4b7de6e4&scoped=true"
import script from "./AssociatedPracticeDialog.vue?vue&type=script&lang=js"
export * from "./AssociatedPracticeDialog.vue?vue&type=script&lang=js"

import "./AssociatedPracticeDialog.vue?vue&type=style&index=0&id=4b7de6e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7de6e4"]])

export default __exports__